'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>最新公告</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 -</router-link> <router-link to="/gonggao">最新公告 -</router-link> <a>{{infobox.title}}</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item active">
                     <router-link to="/gonggao">
                        最新公告 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
            </div>
            <div class="list_right">
               <div class="right_detail">
                  <h5 class="detail_title">{{infobox.title}}</h5>
                  <div class="detail_source">
                     <span v-if="infobox.source != null">来源：{{infobox.source}}</span>
                     <span v-if="infobox.author != null">作者：{{infobox.author}}</span>
                     <span>时间：{{infobox.createTime.substring(0,10)}}</span>
                  </div>
                  <div class="detail_desc" v-html="infobox.content"></div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'list_page',
      components: {},
      data() {
         return {
            infobox: '',
         };
      },
      watch: {
         $route() {
            this.initpage();
         }
      },
      mounted() {
         this.initpage();
      },
      methods: {
         initpage() {
            var _this = this;
            _this.$api.noticeInfo({
               code: _this.$route.params.code
            }).then(res => {
               if (res.code == 200) {
                  _this.infobox = res.data
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });
         }
      }
   }
</script>
<style lang="less" scoped>

</style>
